import { FC } from 'react';

import { AdfoxBannerContainer } from '../../../AdfoxBannerContainer';
import { AdfoxContextProvider, AdfoxContextProviderProps } from '../../context/AdfoxContext';

import style from './FooterBanner.css';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'footer',
  place__DEPRECATED: 'footerSerp',
  name__DEPRECATED: 'Listing_parallax',
};
const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'dbtyp', p2: 'y' };
const SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: 560 };

export const FooterBanner: FC = () => {
  return (
    <div className={style['container']} data-name="FooterBanner">
      <AdfoxContextProvider pParams={P_PARAMS} postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA} size={SIZE}>
        <AdfoxBannerContainer />
      </AdfoxContextProvider>
    </div>
  );
};
